/* eslint-disable */
import React from "react";
import { motion } from "framer-motion";
import { Box, Paper, Typography, useTheme, alpha, Stack } from "@mui/material";
import { Business as BusinessIcon } from "@mui/icons-material";

const CompanyDashboard = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(135deg, #0a0f1e 0%, #0f172a 50%, #1e1b2e 100%)"
            : "linear-gradient(135deg, #fffbeb 0%, #ffffff 50%, #fefce8 100%)",
        p: 3,
      }}
    >
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 900,
              letterSpacing: "-0.025em",
              background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            Dashboard
          </Typography>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <Typography
            variant="body1"
            sx={{
              mt: 1,
              color: theme.palette.mode === "dark" ? "#94a3b8" : "#64748b",
            }}
          >
            Welcome to your dashboard
          </Typography>
        </motion.div>
      </Box>

      {/* Coming Soon Placeholder */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 400,
            borderRadius: "20px",
            background:
              theme.palette.mode === "dark"
                ? alpha("#1e293b", 0.6)
                : alpha("#ffffff", 0.6),
            backdropFilter: "blur(10px)",
            border: `1px solid ${
              theme.palette.mode === "dark"
                ? alpha("#f59e0b", 0.1)
                : alpha("#f59e0b", 0.08)
            }`,
          }}
        >
          <Stack alignItems="center" spacing={2}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "20px",
                background: `linear-gradient(135deg, ${alpha(
                  "#f59e0b",
                  0.15,
                )} 0%, ${alpha("#d97706", 0.1)} 100%)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <BusinessIcon sx={{ fontSize: 40, color: "#f59e0b" }} />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: theme.palette.mode === "dark" ? "#ffffff" : "#1e293b",
              }}
            >
              Dashboard Coming Soon
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.mode === "dark" ? "#94a3b8" : "#64748b",
                maxWidth: 400,
                textAlign: "center",
              }}
            ></Typography>
          </Stack>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default CompanyDashboard;
